import { makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

// 연산 학습지
export class LegacyArithmeticWorksheet extends DTO {
  id: number
  type: 'MASTER' | 'SLAVE'
  title: string
  pdfUrl: string
  answerPdfUrl: string
  thumbnail: string

  constructor(data: res.LegacyArithmeticWorksheet) {
    super()

    this.id = data.id
    this.type = data.type
    this.title = data.title
    this.answerPdfUrl = data.answerPdfUrl
    this.pdfUrl = data.pdfUrl
    this.thumbnail = data.thumbnail
    makeObservable(this, {
      id: observable,
      type: observable,
      title: observable,
      pdfUrl: observable,
      answerPdfUrl: observable,
      thumbnail: observable,
    })
  }
}
